import httpRequest from 'httpRequest'
import { ExtendLicenseResultContract } from 'models'

const LICENSE_PREFIX = '/company/licenses'

const licenseService = {
    renewLicense: () =>
        httpRequest.get<ExtendLicenseResultContract>(`${LICENSE_PREFIX}/renew`),
    getEmailQuotaAmount: () =>
        httpRequest.get<number>(`${LICENSE_PREFIX}/email-quota`),
}

export default licenseService
